// Set $debug = true in the console to activate extra logging goodies.
export default function debug(
  cb: () => void,
  flagName: '$debug' | '$measurePerf' = '$debug'
): void {
  if ((globalThis as any)?.[flagName] === true) {
    return cb();
  }
}
